import React, { useEffect } from "react"
import { useModal, useSession } from "../../hooks/useState"

// Import Swiper
import Swiper, { Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { defPath, fetchPath } from "../../config/defPath"
import gsap from "gsap"
import { useFetch } from "../../hooks/useFetch"
import { BtnComprar } from "../tadaShop/BtnComprar"
import { useGeneralConfig } from "../../hooks/useGeneralConfig"

window.dataLayer = window.dataLayer || [];

export function Controls({ isStadium }: any) {
  const closeModal = useModal(state => state.closeModal)
  const isOpenModal = useModal(state => state.isOpen)

  const openHelp = (e: any) => {
    e.preventDefault()

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Help',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_HelpIcon',
      'element_text': 'Ayuda',
    });

    if (e.currentTarget.href) window.location.href = e.currentTarget.href
  }

  const handdleClose = (event: any) => {
    closeModal()

    if (event.target.classList.contains('muted')) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Sound Off',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_SoundIcon',
        'element_text': 'Sonido',
      });
    }

    else {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Sound On',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_SoundIcon',
        'element_text': 'Sonido',
      });
    }
  }

  return (
    <>
      <section className="layout-controls" style={{ opacity: isOpenModal ? 0 : 1 }}>
        {/* share whatsapp */}
        { isStadium && <BtnShare /> }
        {/* <img className="glow" src={`${defPath}/assets/images/glow_left.png`} alt="" /> */}
        <a href="/estadio-aguila/guia" className="ar__btn hidden" onClick={openHelp}>
          <img className="layout-controls-img" src={`${defPath}/assets/images/icons/icon_help.svg`} alt="icono ayuda" />
        </a>
        {
          isStadium && (
            <>
              <button className="ar__btn UI-sound" onClick={handdleClose}>
                {/* <img className="layout-controls-img" src={`${defPath}/assets/images/icons/icon_volume.svg`} alt="icono volumen" /> */}
              </button>

              <BtnComprar />
            </>
          )
        }
      </section>
    </>
  )
}

export function BtnShare() {
  // const {data, isLoading} = useFetch(`${fetchPath}/aguila/loyalty/get-general-config`)

  const cart = useGeneralConfig(state => state.cart)

  if (!cart) return <></>

  const handleClick = () => {
    window.dataLayer.push({
			'event': 'GAEvent',
			'event_category': 'Content',
			'event_action': 'Button',
			'event_label': `whatsapp - General`,
			'interaction':'true',
			'component_name': 'Modo_Carrera_PrincipalMenu',
			'element_text': `whatsapp`,
		});
  }

  return (
    <div className="layout-controls--share">
      {cart && (
        <a href={cart?.whatsapp} target="_blank" onClick={handleClick}>
          <img src={cart?.whatsapp_icon} alt="share" />
        </a>
      )}
    </div>
  )
}

export function MenuHelp() {
  const { openModal } = useModal(state => state)

  const closeModal = () => {
    const timeline = gsap.timeline({
      defaults: {
        ease: 'power1.in',
        duration: 0.35
      }
    })
    let container = document.querySelector(".ar__modal_overlay");
    timeline.to(container, {
      opacity: 0,
      onComplete() {
        this.targets()[0].style.display = 'none'
        openModal('clear')
      }
    }, 0)
  }

  React.useEffect(() => {
    const swiper = new Swiper('.swiperHelp', {
      modules: [Pagination],
      spaceBetween: 0,
      speed: 200,
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      observer: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    swiper.on('slideNextTransitionEnd', function (event: any) {

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Next - Help',
        'interaction': 'true',
        'component_name': 'Help Instructions',
        'element_text': 'Ayuda',
      });
    });

    swiper.on('slidePrevTransitionEnd', function (event: any) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Prev - Help',
        'interaction': 'true',
        'component_name': 'Help Instructions',
        'element_text': 'Ayuda',
      });
    });
  }, [])

  return (
    <>
      <section className="ar__help">
        <div className="ar__help__title">
          <h2 className="title_2">Instrucciones</h2>
        </div>
        <div className="swiper swiperHelp">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <picture className="icon">
                <source media="(min-width: 991px)" srcSet={`${defPath}/assets/images/help/click.png`} />
                <img src={`${defPath}/assets/images/help/tap.png`} alt="" />
              </picture>
              <div className="text mob">
                <p className="subtitleSmall whiteShadow mob">Toca y arrastra</p>
                <p className="subtitleSmall whiteShadow desk">haz clic y arrastra</p>
                <p className="medium_30 whiteShadow">para moverte</p>
              </div>
            </div>
            <div className="swiper-slide">
              <picture className="icon">
                <source media="(min-width: 991px)" srcSet={`${defPath}/assets/images/help/balon.png`} />
                <img src={`${defPath}/assets/images/help/balon.png`} alt="" />
              </picture>
              <div className="text">
                <p className="subtitleSmall whiteShadow">Toca el balón</p>
                <p className="medium_30 whiteShadow">para moverte</p>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="text">
                <p className="subtitleSmall whiteShadow">Regístrate, <br />guarda tu progreso <br />y compite por <br />premios increíbles.</p>
              </div>
            </div>
          </div>
          <div className="swiper-pagination"></div>
        </div>
        {/* <button className="ar__popup--close black_30" onClick={ closeModal }>
					<span>CERRAR</span>
					<img src={`${defPath}/assets/images/icons/icon-close.svg`} alt="icono close" />
				</button> */}
      </section>
    </>
  )
}

